// extracted by mini-css-extract-plugin
export default {"root":"FamilyInlineInformer__root--38Prt","icon":"FamilyInlineInformer__icon--3OA8T","text":"FamilyInlineInformer__text--3uuIv"};